import React from 'react';
import './CTA.scss';

const CTA = () => {
  return (
    <section className="cta">
      <div className="container">
        <h1>Ready to Transform Your Business?</h1>
        <p>
          Let's discuss how our services can help you achieve your goals and drive success.
        </p>
        <a href="/contact" className="btn">Get Started Today</a>
      </div>
    </section>
  );
};

export default CTA;